// Lightweight CSS-only confetti burst overlay. Triggers via `fireConfetti()`.
import { useEffect, useState } from "react";

let externalTrigger = null;
export function fireConfetti() {
  if (externalTrigger) externalTrigger();
}

const COLORS = ["#3BAD2D", "#00873a", "#fbbf24", "#f59e0b", "#a78bfa", "#7c3aed", "#ef4444"];

export default function ConfettiBurst() {
  const [bursts, setBursts] = useState([]);
  useEffect(() => {
    externalTrigger = () => {
      const id = Math.random().toString(36).slice(2);
      const pieces = Array.from({ length: 70 }, (_, i) => ({
        id: `${id}-${i}`,
        x: 50 + (Math.random() - 0.5) * 6,            // start near center
        rotation: Math.random() * 360,
        color: COLORS[i % COLORS.length],
        dx: (Math.random() - 0.5) * 600,              // horizontal spread
        dy: -180 - Math.random() * 240,               // upward initial
        size: 6 + Math.random() * 8,
        rot: (Math.random() - 0.5) * 720,
        delay: Math.random() * 0.05,
      }));
      setBursts((b) => [...b, { id, pieces, ts: Date.now() }]);
      setTimeout(() => setBursts((b) => b.filter((x) => x.id !== id)), 3000);
    };
    return () => { externalTrigger = null; };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999] overflow-hidden">
      {bursts.map((b) => (
        <div key={b.id} className="absolute inset-0">
          {b.pieces.map((p) => (
            <span
              key={p.id}
              className="absolute"
              style={{
                left: `${p.x}%`,
                top: "55%",
                width: p.size,
                height: p.size * 0.4,
                background: p.color,
                transform: `rotate(${p.rotation}deg)`,
                borderRadius: "2px",
                animation: `confetti-fall 2.2s cubic-bezier(0.25,0.46,0.45,0.94) ${p.delay}s forwards`,
                "--dx": `${p.dx}px`,
                "--dy": `${p.dy}px`,
                "--rot": `${p.rot}deg`,
              }}
            />
          ))}
        </div>
      ))}
      <style>{`
        @keyframes confetti-fall {
          0% { transform: translate(0,0) rotate(0); opacity: 1; }
          15% { transform: translate(calc(var(--dx) * 0.35), calc(var(--dy) * 0.7)) rotate(calc(var(--rot) * 0.3)); opacity: 1; }
          100% { transform: translate(var(--dx), calc(110vh)) rotate(var(--rot)); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
